// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/scss/advice.scss
// module id = 378
// module chunks = 2